<template>
    <div v-if="mutableInspection && hasFeature('feat_online_inspection_report')">
        <el-tooltip :content="tooltipTitle"
                    placement="top">
            <button
                class="font-bold flex items-center text-sm py-1 px-2 rounded-md hover-pointer whitespace-nowrap transition duration-300"
                :class="[mutableInspection.online_report_status === 'shared' ?
                'bg-green-100 text-green-600 hover:bg-green-200 hover:text-green-800 border-none' :
                'bg-yellow-100 text-yellow-600 hover:bg-yellow-200 hover:text-yellow-800',
                buttonClass]"
                @click.prevent="toggleInspectionSharingForm()">
                <icon-check-circle v-if="mutableInspection.online_report_status === 'shared'" class="w-4 h-4 inline mr-2"></icon-check-circle>
                <icon-link v-else-if="mutableInspection.online_report_status === 'generated'" class="w-4 h-4 inline mr-2"></icon-link>
                Online Report
            </button>
        </el-tooltip>

        <inspection-online-report-sharing-modal
            v-if="showInspectionSharingForm"
            :show="showInspectionSharingForm"
            :inspection="mutableInspection"
            @close="toggleInspectionSharingForm(false)"
            @update-online-report-status="emitOnlineReportUpdate">
        </inspection-online-report-sharing-modal>
    </div>
</template>

<script>
import InspectionOnlineReportSharingModal from "./InspectionOnlineReportSharingModal.vue";

export default {
    components: {InspectionOnlineReportSharingModal},

    props: {
        inspection: {
            type: Object,
            required: true,
        },
        buttonClass: {
            type: String,
            default: "",
        },
    },

    data () {
        return {
            showInspectionSharingForm: false,
            mutableInspection: null,
        };
    },

    watch: {
        inspection (newVal) {
            this.mutableInspection = newVal;
        },
    },

    mounted () {
        this.mutableInspection = this.inspection;
    },

    computed: {
        tooltipTitle () {
            switch (this.mutableInspection.online_report_status) {
                case "shared":
                    return "Online report link shared with one or more contacts";
                case "generated":
                    return "Online report link not shared yet";
                case "not generated":
                default:
                    return "No online report link generated";
            }
        },
    },

    methods: {
        toggleInspectionSharingForm (override = null) {
            if (override) {
                this.showInspectionSharingForm = override;
                return;
            }

            this.showInspectionSharingForm = !this.showInspectionSharingForm;
        },

        emitOnlineReportUpdate (inspectionId, value) {
            // Need this function to emit the correct parameters from the child component to the child's grandparent
            this.$emit("update-online-report-status", inspectionId, value);
        }
    },
};
</script>